import { FC } from 'react'
import { PoiLayers } from './poi/PoiLayers.tsx'
import { useAtomValue } from 'jotai'
import { poisAtom } from '@/js/editor/state/mapAtoms.ts'

type LayerProps = {
    options?: object
}

export const Layers: FC<LayerProps> = () => {
    const pois = useAtomValue(poisAtom)

    return pois.length > 0 ? <PoiLayers pois={pois} /> : null
}
